import { headerActionTypes } from '../constants/headerActionTypes';

export const toggleHeader = () => {
  return {
    type: headerActionTypes.SET_HEADER_TOGGLE,
  };
};
